import React, { useEffect } from 'react';

export const ReloadEnterAccessPass = () => {
  useEffect(() => {
    localStorage.setItem('enteredPasscode', false);
  }, []);

  return <></>;
};
